/* global axios */

import ApiClient from './ApiClient';

class InternalChatAPI extends ApiClient {
  constructor() {
    super('internal_chat', { accountScoped: true });
  }

  getRooms() {
    return axios.get(`${this.url}/rooms`);
  }

  createRoom(payload) {
    return axios.post(`${this.url}/rooms`, payload);
  }

  showRoom(roomId) {
    return axios.get(`${this.url}/rooms/${roomId}`);
  }

  updateRoom(roomId, payload) {
    return axios.patch(`${this.url}/rooms/${roomId}`, payload);
  }

  archiveRoom(roomId) {
    return axios.delete(`${this.url}/rooms/${roomId}`);
  }

  getMessages({ roomId, beforeId, limit = 50 }) {
    return axios.get(`${this.url}/rooms/${roomId}/messages`, {
      params: { before_id: beforeId, limit },
    });
  }

  createMessage(roomId, payload) {
    return axios.post(`${this.url}/rooms/${roomId}/messages`, payload);
  }

  updateMessage({ roomId, messageId, payload }) {
    return axios.patch(
      `${this.url}/rooms/${roomId}/messages/${messageId}`,
      payload
    );
  }

  deleteMessage({ roomId, messageId }) {
    return axios.delete(`${this.url}/rooms/${roomId}/messages/${messageId}`);
  }

  markRead({ roomId, messageId }) {
    return axios.post(`${this.url}/rooms/${roomId}/read`, {
      message_id: messageId,
    });
  }

  createMembership({ roomId, userIds }) {
    return axios.post(`${this.url}/rooms/${roomId}/memberships`, {
      user_ids: userIds,
    });
  }

  updateMemberships({ roomId, userIds }) {
    return axios.patch(`${this.url}/rooms/${roomId}/memberships`, {
      user_ids: userIds,
    });
  }

  removeMembership({ roomId, userId }) {
    return axios.delete(`${this.url}/rooms/${roomId}/memberships/${userId}`);
  }

  getUsers() {
    return axios.get(`${this.url}/users`);
  }

  search(query) {
    return axios.get(`${this.url}/search`, { params: { q: query } });
  }
}

export default new InternalChatAPI();
